<template>
  <!-- 输入框选择器 -->
  <div class="filter_div">
    <div class="header_div">
      <el-button type="text" size="mini" @click="ascOrderAction()"
        >↑升序</el-button
      >
      <el-button type="text" size="mini" @click="descOrderAction()"
        >↓降序
      </el-button>
    </div>
    <div v-if="!isFilter">
      <el-input
        style="width: 100%"
        type="textarea"
        :rows="4"
        placeholder="请输入过滤词，过滤词之间以逗号隔开"
        v-model="inputSearch"
        @input="filterOptions"
      ></el-input>
    </div>
    <div v-if="isFilter" v-loading="isLoading">
      <el-input
        style="width: 100%"
        placeholder="请输入过滤词"
        v-model="inputSearch"
        @input="filterOptions"
      ></el-input>
      <div class="checkHeader">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
      </div>
      <div id="overflowTest">
        <!-- <div style="margin: 15px 0;"></div> -->
        <el-checkbox-group
          class="title-list"
          v-model="selOptions"
          @change="checkChange"
        >
          <el-checkbox
            class="titles"
            v-for="(allItem, allItemIndex) in filtedOptions"
            :label="allItem"
            :key="allItemIndex"
            >{{ allItem }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <div class="filterBottom">
      <button @click="cancel" style="margin-right: 0.625rem">取消</button>
      <button
        :class="{ 'is-disabled': selOptions.length === 0 }"
        v-if="isFilter"
        @click="todoFilter"
      >
        筛选
      </button>
      <button @click="trueFilter" v-else>确定</button>
    </div>
  </div>
</template>

<script>
import Bus from "../js/Bus.js";

export default {
  props: {
    filterkey: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "unit",
    },
    ftn: {
      type: String,
      default: "",
    },
    refname: {
      type: String,
      default: "",
    },
    clmnFilter: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    console.log("range data funciton");
    return {
      allOptions: [], // 全部列
      filtedOptions: [], //过滤的列
      selOptions: [], // 已选择列
      inputSearch: "",
      isIndeterminate: false,
      checkAll: false,
      isLoading: false,
      isFilter: true,
    };
  },

  mounted() {
    console.log("range mounted 触发");
    Bus.$on("LOAD_OPTION_DATA", (options, state, key, show) => {
      // // console.log("------是否筛选模式：", show);
      // console.log("------是否loading：", state);
      if (show === true) {
        this.isLoading = state;
      }
      this.isFilter = show;
      this.allOptions = [];
      this.allOptions = options;
      this.filtedOptions = this.allOptions;
      this.inputSearch = "";
      this.selOptions = [];
      if (state === false) {
        let keyList = this.clmnFilter[key];
        // this.isFilter = show;
        if (keyList && keyList.length > 0) {
          this.selOptions = keyList;
        }
      }
      this.isIndeterminate = false;
    });
  },

  methods: {
    // todoFilter() {
    // 	if (this.value1 && this.value2) {
    // 		this.$emit('getFilterBridge', {
    // 			key: this.filterkey,
    // 			label: this.value1 + '-' + this.value2 + this.unit,
    // 			value: this.value1 + ',' + this.value2,
    // 			ftn: this.ftn
    // 		})
    // 	}
    // },
    todoFilter() {
      console.log("range todoFilter unit = ", this.unit);
      if (this.selOptions.length > 0) {
        this.$emit("getFilterBridge", {
          label: this.ftn,
          key: this.filterkey,
          options: this.selOptions,
          value: this.selOptions.join(","),
          ftn: this.ftn,
          order: null,
          action: "1", //1-筛选 2-取消 3-排序  4-输入搜索
        });
      }
    },
    trueFilter() {
      this.$emit("getFilterBridge", {
        label: this.ftn,
        key: this.filterkey,
        options: [...this.inputSearch.split(",")],
        value: this.inputSearch,
        ftn: this.ftn,
        order: null,
        action: "4", //1-筛选 2-取消 3-排序
      });
    },

    cancel() {
      console.log("range cancel action");
      this.$emit("getFilterBridge", {
        key: this.filterkey,
        label: this.unit,
        value: "",
        ftn: null,
        action: "2",
      });
    },

    checkChange() {
      console.log("range checkChange selOption = ", this.selOptions);
    },

    ascOrderAction() {
      console.log("range ascOrderAction ");
      this.$emit("getFilterBridge", {
        label: this.ftn,
        key: this.filterkey,
        options: this.selOptions,
        value: this.selOptions.join(","),
        ftn: this.ftn,
        order: "1",
        action: "3",
      });
    },

    descOrderAction() {
      console.log("range descOrderAction");
      this.$emit("getFilterBridge", {
        label: this.ftn,
        key: this.filterkey,
        options: this.selOptions,
        value: this.selOptions.join(","),
        ftn: this.ftn,
        order: "2",
        action: "3",
      });
    },

    handleCheckAllChange(val) {
      console.log("range handleCheckAllChange val = ", val);
      this.selOptions = val ? this.filtedOptions : [];
      this.isIndeterminate = false;
    },

    filterOptions(e) {
      console.log("range filterOptions val = ", this.inputSearch);
      console.log("range filterOptions e = ", e);

      if (e.length > 0) {
        console.log("filterOptions 111");
        this.filtedOptions = this.allOptions.filter(function (item) {
          // console.log('range filterOptions item = ', item)
          return item.indexOf(e) !== -1;
        });
      } else {
        console.log("filterOptions 222");
        this.filtedOptions = this.allOptions;
      }
    },
  },
};
</script>

<style scoped>
@import url("../css/common.css");

.editFilter {
  position: absolute;
  width: 300px;
}

.filterWrap .filterBottom {
  padding: 8px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
}

.filterWrap .filterBottom button {
  background: #1577d2;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 8px;
}

.filter_div {
  padding: 10px;
  background-color: #ffffff;
  width: 18.75rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  left: 0;
}

.header_div {
  width: 100%;
  height: 2.5rem;
  background-color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.input_div {
  width: 100%;
  height: 3.75rem;
  background-color: #ffffff;
  display: flex;
  align-items: center;
}

.checkHeader {
  display: flex;
  justify-content: flex-start;
  /* margin-bottom: 0.5rem; */
  padding: 0.625rem;
}

#overflowTest {
  background: #ffffff;
  color: white;
  /* padding: 15px; */
  width: 100%;
  height: 12.5rem;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* border: 1px solid #ccc; */
}

.title-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 0.625rem;
}
</style>
